exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.custom-table-other .el-table__header-wrapper{\n\theight: 0px;\n}\n", ""]);

// exports
